/*
 * @Author: 陶慧灵
 * @Date: 2022-10-21 09:01:18
 * @LastEditors: wenbei421 346972930@qq.com
 * @LastEditTime: 2022-11-17 14:48:32
 * @Descripttion:
 * @FilePath: \src\ics-imedx-chromely-plugin-index-examine.ts
 */
import IndexExamine from './index-examine'
import DictIndex from './dict-index-examine'
import Icd10Index from './icd10-index-examine'
import IcdTcmIndex from './icdtcm-index-examine'
import SysAreaIndex from './sys-area-index-examine'
import Icd9cm3Index from './icd9-cm3-index-examine'
import DictDrugBaseIndex from './dict-drug-base-index-examine'
import DictDrugPharmacologyIndex from './dict-drug-pharmacology-index-examine'

export default {
  IndexExamine,
  DictIndex,
  Icd10Index,
  IcdTcmIndex,
  SysAreaIndex,
  Icd9cm3Index,
  DictDrugBaseIndex,
  DictDrugPharmacologyIndex
}

// export { IndexExamine, DictIndex, Icd10Index, IcdTcmIndex, SysAreaIndex, Icd9cm3Index, DictDrugBaseIndex , DictDrugPharmacologyIndex}
